import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noNewFriend.png'


const _withScopeId = n => (_pushScopeId("data-v-0dc30dc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "messageItem"
}
const _hoisted_4 = { class: "messageRightBox" }
const _hoisted_5 = { class: "leftmsg" }
const _hoisted_6 = {
  key: 0,
  class: "name"
}
const _hoisted_7 = {
  key: 1,
  class: "name"
}
const _hoisted_8 = {
  key: 1,
  class: "nodata"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('im.group'),
      "left-arrow": "",
      fixed: "",
      "safe-area-inset-top": "",
      onClickLeft: $setup.onClickLeft
    }, null, 8 /* PROPS */, ["title"]),
    ($setup.msgList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.msgList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => ($setup.toChat(item))
            }, [
              (item.isGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_van_image, {
                      round: "",
                      width: "50",
                      fit: "cover",
                      height: "50",
                      src: item.headurl
                    }, null, 8 /* PROPS */, ["src"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (item.nickname)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.nickname), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('im.group')), 1 /* TEXT */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_2))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('noData.nogroup')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('tips.tosendZb')), 1 /* TEXT */)
        ]))
  ], 64 /* STABLE_FRAGMENT */))
}